import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { CustomersPage } from './_dashboard.customers'

export const Route = createFileRoute('/_dashboard/customers/')({
  beforeLoad: requireAuth(),
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: CustomersIndexPage,
})

function CustomersIndexPage() {
  return <CustomersPage selectedId={undefined} />
}
